// ** Initial State
const initialState = {
  allData: [],
  data: [],
  total: 1,
  params: {},
  selectedElement: null
}

const elements = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_ALL_ELEMENTS':
      return { ...state, allData: action.data }
    case 'FILTER_ALL_ELEMENTS':
      return {
        ...state,
        data: action.data,
        total: action.totalPages,
        params: action.params
      }
    case 'GET_ELEMENT':
      return { ...state, selectedElement: action.selectedElement }
    case 'ADD_ELEMENT':
      return { ...state }
    case 'DELETE_ELEMENT':
      return { ...state }
    default:
      return { ...state }
  }
}
export default elements
